import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RelationshipDataItem } from '../models/partner';


@Component({
  selector: 'app-picklist-asset-group',
  templateUrl: './picklist-asset-group.component.html',
  styleUrls: ['./picklist-asset-group.component.scss']
})
export class PicklistAssetGroupComponent implements OnInit {

  @Input() availableGroup: RelationshipDataItem[];
  @Input() selectedGroup: RelationshipDataItem[];
  @Input() showSourceFilter: boolean;
  @Input() showTargetFilter: boolean;
  @Input() loading: boolean;
  @Output() onAssetGroupChange = new EventEmitter<RelationshipDataItem[]>();
  @Output() onAssetGroupFilter = new EventEmitter<string>();
  disableAssetGroup: Boolean;

  constructor() { }

  ngOnInit() { }

  @Input()
  set disabled(flag: boolean) {
    this.disableAssetGroup = flag;
  }

  change() {
   this.onAssetGroupChange.emit(this.selectedGroup);
  }

}
